import React from 'react';
import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { Badge } from 'Components/frameworks/badge/Badge';
type TransferBulletPointsProps = {
  title: string;
  bulletPoints: Array<string>;
};
export const TransferBulletPoints = ({ title, bulletPoints }: TransferBulletPointsProps) => {
  const filteredBulletPoints = bulletPoints
    .map((bulletPoint) => t(bulletPoint)) // this filter is keep only translated bullet points and non null
    .filter((bulletPoint, index) => bulletPoint !== bulletPoints[index] && bulletPoint !== '');
  return (
    <div
      data-testid="TransferBulletPoints"
      className="h-full rounded-16 border-1 border-lightGrey bg-white p-20"
    >
      <div data-testid="TransferBulletPoints-icon" className="flex items-start gap-20">
        <Badge
          className="size-48 border-lightSand bg-lightSand text-black"
          iconName={ICONS.CAR}
          iconSize="24px"
          variant="pill"
        />
        <div className="text-start text-16 leading-normal">
          <p className="mb-8 font-semibold">{t(title)}</p>
          <ul className="list-none">
            {filteredBulletPoints?.map((bulletPointSingleInfo, index) => (
              <li className="list-disc" key={`TransferBulletPoints-${index * 1}`}>
                {bulletPointSingleInfo}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
